import config from './1config';
import load_loaders from './2loaders';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment'; // 이것은 여기를 따라야 함.
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// dayjs 플러그인 조기 로딩 (ngx-daterangepicker-material 라이브러리 호환성)
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(utc);
dayjs.extend(isoWeek);


if (config.env === "prod") {
  enableProdMode();
  load_loaders()
  if(window){
    window.console.log = function(){};
    window.console.group = function(){};
    window.console.groupEnd = function(){};
    window.console.table = function(){};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
